<template>

  <div class="akkordeon-container">

    <template v-for="item in list">
      <akkordeon-item :item="item"></akkordeon-item>
    </template>

  </div>

</template>

<script>
import AkkordeonItem from "./AkkordeonItem";
export default {
  name: 'Akkordeon',
  components: {AkkordeonItem},
  data() {
    return {
      loading: true
    }
  },
  props: {
    list: null
  }
}
</script>



<style scoped lang="scss">
.akkordeon-container {
  max-width: 1024px;
  margin: 0 auto;
  padding: 0px 80px;
  box-sizing: border-box;
  margin-bottom: 0px;

  @media screen and (max-width: 768px) {
    padding: 0px;
  }
  @media screen and (max-width: 480px) {
    padding: 0px;
  }
}

</style>
